<template>
  <b-container>
    <b-row class="ja-decoration">
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-col cols="12" class="mt-1 title">{{ $t("verify_email_password_title_one") }} <br>
          {{ $t("verify_email_password_title_two") }}
        </b-col>
      </b-col>
      <b-col cols="12">
        <b-col cols="12" class="mt-3 py-3">
          <p class="text pb">
            {{ $t("verify_email_password_sent_email") }}<span class="email">{{this.$route.params.email}}</span>,
            {{ $t("verify_email_password_paragraph") }}
          </p>
          <p class="text ">
            {{ $t("verify_email_password_second_paragraph") }}
          </p>
        </b-col>
      </b-col>
      <b-col cols="12">
        <b-col cols="12" class="mt-2 button-content">
          <b-button block variant="primary" :to="{ name: 'Login' }">
            {{ $t("verify_email_password_button_text") }}
          </b-button>
        </b-col>
      </b-col>
    </b-row>
    <legal-message />
  </b-container>
</template>

<script>
import LegalMessage from "../Components/LegalMessage"

export default {
  name: 'verifyEmailPassword',
  components: {LegalMessage}
}
</script>

<style lang="stylus" scoped>
@import "~@/core/Styles/variables.styl"
@import "../Styles/security_styles.styl"

.email
  font font-sourcesans-bold
  font-size 16px
  font-weight bold
  color color-brown
  line-height 25px
</style>
